// extracted by mini-css-extract-plugin
export default {"idleAnimation":"Affirmative-module__idleAnimation--wTX6P","runningAnimation":"Affirmative-module__runningAnimation--pqEJR","copilotRun":"Affirmative-module__copilotRun--kyiZX"};